import { createWebHistory, createRouter } from 'vue-router'

import newsView from '../views/news/newsView.vue' 
import strategyView from '../views/strategy/strategyView.vue'
import complaintView from '../views/complaint/complaintView.vue'
import dynamicsView from '../views/dynamics/dynamicsView.vue'
import contactView from '../views/contact/contactView.vue'
import memberView from '../views/member/memberView.vue'
import popular from '../views/news/popular.vue' 
import flash from '../views/news/flash.vue' 
import important from '../views/news/important.vue' 
import newsText from '@/views/news/newsText.vue'
import popularText from '@/views/news/popularText.vue'
import flashText from '@/views/news/flashText.vue'
import importantText from '@/views/news/importantText.vue'
import NewsDetail1 from '@/views/dynamics/NewsDetail1.vue'
import about from '@/views/about/about.vue'
// import NewsDetail2 from '@/views/dynamics/NewsDetail2.vue'


import menberDetail from '@/views/member/memberDetail/memberDetail.vue' 

const routes = [
    {
        path: '/',
        name: "strategy",
        // redirect:"/strategy",
        component: strategyView
    },
    
    {
        path: '/news', //跳转的路径
        name: 'news ',//命名路由，也可以不写
        component: newsView //跳转到对应的组件

    },
    {
        path:'/popular',
        name:'popular',
        component:popular
    },
    {
        path:'/flash',
        name:'flash',
        component:flash
    },
    {
        path:'/important',
        name:'important',
        component:important
    },
    {
        path: '/news/:id', // 使用动态路由匹配新闻ID
        name: 'newsText',
        component: newsText,
        props: true, // 允许newsText组件接收props
      },
    {
        path: '/popular/:id', // 使用动态路由匹配新闻ID
        name: 'popularText',
        component: popularText,
        props: true, 
      },
    {
        path: '/flash/:id', // 使用动态路由匹配新闻ID
        name: 'flashText',
        component: flashText,
        props: true, 
      },
    {
        path: '/important/:id', // 使用动态路由匹配新闻ID
        name: 'importantText',
        component: importantText,
        props: true, 
      },

    // {
    //     path:'/newsText',
    //     name:'newsText',
    //     component:NewsText
    // },
    {
        path: '/complaint', 
        path: '/complaint',
        name: 'complaint',
        component: complaintView
    },
    {
        path: '/dynamics',
        name: 'dynamics',
        component: dynamicsView
    },
    
    {
        path: '/NewsDetail1/:id', // 使用动态路由匹配新闻ID
        name: 'NewsDetail1',
        component:NewsDetail1,
        // component: () => import('@/views/dynamics/NewsDetail1.vue'),
        props: true, // 允许companyText组件接收props
    },
    {
        path: '/contact', 
        name: 'contact',
        component: contactView
    },
    {
        path: '/member',
        name: 'member',
        component: memberView
    },
    {
        path: '/memberDetail', 
        name: 'memberDetail',
        component: menberDetail 
    }, 
    {
        path: '/about', 
        name: 'about',
        component: about
    }
   
]

const router = createRouter({
    //   history: createWebHashHistory(),//hash的模式，如#/home，#/center  带#号的路径
    history: createWebHistory(),//web的模式，如/home，/center  不带#号的路径
    routes,//`routes:routes`的缩写
})

export default router
